import cc from 'classcat'
import React from 'react'

import { ReconcilablePostingType } from '@modules-deprecated/bankReconciliation/types'

import { reactClass } from '../../utils'
import * as Styled from './styles'

export type StatusIconProps = {
  className?: string
  status: ReconcilablePostingType
}

export const StatusIcon = ({ className, status }: StatusIconProps) => {
  return <Styled.StatusIndicator className={cc([className, reactClass('status-icon')])} color={status} />
}
